import {
    Col, Extra, Form,
    FormLabel, Layout, Mask,
    Money,
    MoneyUnit, Overlay, Placeholder, QRCodeContainer,
    Row, Subject
} from "./styles";
import PaymentTip from "src/component/PaymentTip";
import React, {useEffect, useMemo, useState} from "react";
import {GamePayment, LocalUser, Payment} from "src/typing";
import {isErrorException} from "@firefly/fly-http";
import {Spin} from "antd";
import {useViewerCreateCoinPaymentMutation} from "../../hook/payment";
// import useMemoizedFn from "@firefly/fly-kda/dist/hook/useMemoizedFn";
import {usePaymentWatch} from "../../../connect/gamepay/hook";
import {useOrderWatch} from "../../hook/order";
import useMemoizedFn from "../../../hook/useMemoizedFn";
import QRCode from "../../../component/QRCode";

export interface GiftPaymentFormProps {
    user?: LocalUser | null;

    subject: string;
    extra: string;
    gameId: string;
    level: number;
    // outOrderNo: string
    // attach: string;
    // target: GameTarget;
    // originalAmount: string;

    isLoading?: boolean;
    onFinish?: () => void;
}
function GiftPaymentForm(props: GiftPaymentFormProps) {
    const {
        user,
        // outOrderNo,
        // attach,
        gameId,
        isLoading,
        onFinish: _onFinish,
        subject,
        extra,
        level,
    } = props;
    const [payment, setPayment] = useState<Payment>();
    const [content, setContent] = useState<string>();
    const {
        mutateAsync: createPayment,
        isLoading: createLoading,
        error,
    } = useViewerCreateCoinPaymentMutation();

    const create = useMemoizedFn(() => {
        createPayment({
            gameId: gameId,
            level: level!,
        }).then((output) => {
            // console.log(output)
            setPayment(output)
            setContent(`http://paygateway.niu.niuxyx.com/vippay/payment-order.html?orderNo=${output.paymentOrderNo}`)
        })
    });
    useEffect(() => {
        if (level) {
            create()
        }

    }, []);

    // console.log(payment)
    const {
        data
    } = useOrderWatch(payment?.orderNo);

    const onFinish = useMemoizedFn(() => {
        _onFinish?.()
    })
    useEffect(() => {
        if (data?.paymentState === 'PAID') {
            onFinish?.();
        }
    }, [data, onFinish]);

    const errorMessage = useMemo<React.ReactElement | undefined>(() => {
        if (error) {
            if (isErrorException(error)) {
                return <React.Fragment>
                    {error.message}
                </React.Fragment>
            } else {
                return <React.Fragment>错误</React.Fragment>
            }
        }
        return undefined;
    }, [error]);

    if (isLoading) {
        return <Layout>
            <Spin />
        </Layout>
    }


    function renderPayment() {

    }
    return <Layout>
        <Form>
            <Row>
                <Col span={4}>
                    <FormLabel>游戏账号：</FormLabel>
                </Col>
                <Col span={20}>
                    {user?.username??user?.uid}
                </Col>
            </Row>
            <Row>
                <Col span={4}>
                    <FormLabel>购买：</FormLabel>
                </Col>
                <Col span={20}>
                    <Subject>
                        {subject}
                    </Subject>
                    <Extra>
                        {extra}
                    </Extra>
                </Col>
            </Row>
            <Row>
                <Col span={4}>
                    <FormLabel>应付金额：</FormLabel>
                </Col>
                <Col span={20}>
                    {payment ?
                        <Money>
                            <span>{payment?.amount}</span>
                            <MoneyUnit>元</MoneyUnit>
                        </Money>
                        : null}
                </Col>
            </Row>
            <Row>
                <Col span={20} offset={4}>
                    <QRCodeContainer>
                        <QRCode
                            size={128}
                            value={content}
                            isLoading={isLoading || createLoading}
                            error={errorMessage}
                        />
                        {/*<QRCode*/}
                        {/*    value={content??"failure"}*/}
                        {/*    status={isLoading || createLoading ? 'loading' : 'active'}*/}
                        {/*    onRefresh={() => create()}*/}
                        {/*/>*/}
                        {errorMessage ? <Overlay>
                            <Placeholder>
                                {errorMessage}
                            </Placeholder>
                            <Mask />
                        </Overlay>  : null}
                    </QRCodeContainer>
                    {/*<QRCodeContainer>*/}
                        {/*<QRCode*/}
                        {/*    size={128}*/}
                        {/*    value={content}*/}
                        {/*    isLoading={isLoading || createLoading}*/}
                        {/*    error={errorMessage}*/}
                        {/*/>*/}
                    {/*</QRCodeContainer>*/}
                    <PaymentTip />
                </Col>
            </Row>
        </Form>
    </Layout>
}


export default GiftPaymentForm;